import styled from "@emotion/styled";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import React from "react";

import theme from "../../theme";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: ${theme.color("primary.base")};
  color: white;
  padding: ${theme.spacing("xl")} 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TickerWrap = styled.div`
  position: relative;
  width: 100vw;
  max-width: 100%;
  height: 30px;
  overflow: hidden;
`;

const ItemsWrapper = styled(motion.div)`
  position: absolute;
  white-space: nowrap;
  will-change: transform;
`;

const Item = styled.span`
  display: inline-block;
  padding: 0 2.5rem;
  font-size: ${theme.fs("h4")};
`;

function Ticker({ items }) {
  const repeat = new Array(8).fill().map((x, i) => i);
  const tickerSpeed = items.length * 35;
  return (
    <Wrapper>
      <TickerWrap>
        <ItemsWrapper
          animate={{ x: "-50%" }}
          transition={{
            repeat: Infinity,
            duration: tickerSpeed,
            ease: "linear",
          }}
        >
          {repeat.map((r) =>
            items.map((item, i) => <Item key={`${r}-${i}`}>{item}</Item>)
          )}
        </ItemsWrapper>
      </TickerWrap>
    </Wrapper>
  );
}

Ticker.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};

export default Ticker;
